import { N as b } from "./referencePickerModal-c2f33569.mjs";
import h from "@nextcloud/axios";
import { generateOcsUrl as d } from "@nextcloud/router";
import { n as g } from "./_plugin-vue2_normalizer-71e2aa87.mjs";
import { visit as _, SKIP as v } from "unist-util-visit";
import { u as l } from "unist-builder";
import { unified as y } from "unified";
import w from "remark-parse";
import R from "remark-breaks";
import N from "remark-rehype";
import A from "rehype-react";
import L from "rehype-external-links";
const m = /(\s|^)(https?:\/\/)((?:[-A-Z0-9+_]+\.)+[-A-Z]+(?:\/[-A-Z0-9+&@#%?=~_|!:,.;()]*)*)(\s|$)/ig, x = /(\s|\(|^)((https?:\/\/)((?:[-A-Z0-9+_]+\.)+[-A-Z0-9]+(?::[0-9]+)?(?:\/[-A-Z0-9+&@#%?=~_|!:,.;()]*)*))(?=\s|\)|$)/ig, $ = {
  name: "NcReferenceList",
  components: {
    NcReferenceWidget: b
  },
  props: {
    text: {
      type: String,
      default: ""
    },
    referenceData: {
      type: Object,
      default: null
    },
    limit: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      references: null,
      loading: !0
    };
  },
  computed: {
    isVisible() {
      return this.loading || this.displayedReferences;
    },
    values() {
      return this.referenceData ? this.referenceData : this.references ? Object.values(this.references) : [];
    },
    firstReference() {
      var e;
      return (e = this.values[0]) != null ? e : null;
    },
    displayedReferences() {
      return this.values.slice(0, this.limit);
    }
  },
  watch: {
    text: "fetch"
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      if (this.loading = !0, this.referenceData) {
        this.loading = !1;
        return;
      }
      if (!new RegExp(m).exec(this.text)) {
        this.loading = !1;
        return;
      }
      this.resolve().then((e) => {
        this.references = e.data.ocs.data.references, this.loading = !1;
      }).catch((e) => {
        console.error("Failed to extract references", e), this.loading = !1;
      });
    },
    resolve() {
      const e = new RegExp(m).exec(this.text.trim());
      return this.limit === 1 && e ? h.get(d("references/resolve", 2) + `?reference=${encodeURIComponent(e[0])}`) : h.post(d("references/extract", 2), {
        text: this.text,
        resolve: !0,
        limit: this.limit
      });
    }
  }
};
var j = function() {
  var s = this, t = s._self._c;
  return s.isVisible ? t("div", { staticClass: "widgets--list", class: { "icon-loading": s.loading } }, s._l(s.displayedReferences, function(r) {
    var i;
    return t("div", { key: (i = r == null ? void 0 : r.openGraphObject) == null ? void 0 : i.id }, [t("NcReferenceWidget", { attrs: { reference: r } })], 1);
  }), 0) : s._e();
}, T = [], O = /* @__PURE__ */ g(
  $,
  j,
  T,
  !1,
  null,
  "bd1fbb02",
  null,
  null
);
const f = O.exports, C = {
  name: "NcLink",
  props: {
    href: {
      type: String,
      required: !0
    }
  },
  render(e) {
    return e("a", {
      attrs: {
        href: this.href,
        rel: "noopener noreferrer",
        target: "_blank",
        class: "rich-text--external-link"
      }
    }, [this.href.trim()]);
  }
}, M = function({ autolink: e, useMarkdown: s }) {
  return function(t) {
    !s || !e || _(t, (r) => r.type === "text", (r, i, n) => {
      let c = k(r.value);
      return c = c.map((a) => typeof a == "string" ? l("text", a) : l("link", {
        url: a.props.href
      }, [l("text", a.props.href)])).filter((a) => a), n.children.splice(i, 1, ...c.flat()), [v, i + c.flat().length];
    });
  };
}, k = (e) => {
  let s = x.exec(e);
  const t = [];
  let r = 0;
  for (; s !== null; ) {
    let n = s[2], c, a = e.substring(r, s.index + s[1].length);
    n[0] === " " && (a += n[0], n = n.substring(1).trim());
    const o = n[n.length - 1];
    (o === "." || o === "," || o === ";" || s[0][0] === "(" && o === ")") && (n = n.substring(0, n.length - 1), c = o), t.push(a), t.push({ component: C, props: { href: n } }), c && t.push(c), r = s.index + s[0].length, s = x.exec(e);
  }
  t.push(e.substring(r));
  const i = t.map((n) => typeof n == "string" ? n : n.props.href).join("");
  return e === i ? t : (console.error("Failed to reassemble the chunked text: " + e), e);
}, D = function() {
  return function(e) {
    _(e, (t) => t.type === "text", s);
    function s(t, r, i) {
      const n = t.value.split(/(\{[a-z\-_.0-9]+\})/ig).map((c, a, o) => {
        const p = c.match(/^\{([a-z\-_.0-9]+)\}$/i);
        if (!p)
          return l("text", c);
        const [, u] = p;
        return l("element", {
          tagName: `#${u}`
        });
      });
      i.children.splice(r, 1, ...n);
    }
  };
}, E = ({ h: e, context: s }, t) => (s.autolink && (t = k(t)), Array.isArray(t) ? t.map((r) => {
  if (typeof r == "string")
    return r;
  const { component: i, props: n } = r, c = i.name === "NcLink" ? void 0 : "rich-text--component";
  return e(i, {
    props: n,
    class: c
  });
}) : t), P = {
  name: "NcRichText",
  components: {
    NcReferenceList: f
  },
  props: {
    text: {
      type: String,
      default: ""
    },
    arguments: {
      type: Object,
      default: () => ({})
    },
    referenceLimit: {
      type: Number,
      default: 0
    },
    /** Provide data upfront to avoid extra http request */
    references: {
      type: Object,
      default: null
    },
    markdownCssClasses: {
      type: Object,
      default: () => ({
        a: "rich-text--external-link",
        ol: "rich-text--ordered-list",
        ul: "rich-text--un-ordered-list",
        li: "rich-text--list-item",
        strong: "rich-text--strong",
        em: "rich-text--italic",
        h1: "rich-text--heading rich-text--heading-1",
        h2: "rich-text--heading rich-text--heading-2",
        h3: "rich-text--heading rich-text--heading-3",
        h4: "rich-text--heading rich-text--heading-4",
        h5: "rich-text--heading rich-text--heading-5",
        h6: "rich-text--heading rich-text--heading-6",
        hr: "rich-text--hr",
        table: "rich-text--table",
        pre: "rich-text--pre",
        code: "rich-text--code",
        blockquote: "rich-text--blockquote"
      })
    },
    useMarkdown: {
      type: Boolean,
      default: !1
    },
    autolink: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    renderPlaintext(e) {
      const s = this, t = this.text.split(/(\{[a-z\-_.0-9]+\})/ig).map(function(r, i, n) {
        const c = r.match(/^\{([a-z\-_.0-9]+)\}$/i);
        if (!c)
          return E({ h: e, context: s }, r);
        const a = c[1], o = s.arguments[a];
        if (typeof o == "object") {
          const { component: p, props: u } = o;
          return e(p, {
            props: u,
            class: "rich-text--component"
          });
        }
        return o ? e("span", { class: "rich-text--fallback" }, o) : r;
      });
      return e("div", { class: "rich-text--wrapper" }, [
        e("div", {}, t.flat()),
        this.referenceLimit > 0 ? e("div", { class: "rich-text--reference-widget" }, [
          e(f, { props: { text: this.text, referenceData: this.references } })
        ]) : null
      ]);
    },
    renderMarkdown(e) {
      const s = y().use(w).use(M, {
        autolink: this.autolink,
        useMarkdown: this.useMarkdown
      }).use(R).use(N, {
        handlers: {
          component(t, r) {
            return t(r, r.component, { value: r.value });
          }
        }
      }).use(D).use(L, {
        target: "_blank",
        rel: ["noopener noreferrer"]
      }).use(A, {
        createElement: (t, r, i) => {
          if (i = i == null ? void 0 : i.map(
            (c) => typeof c == "string" ? c.replace(/&lt;/gmi, "<") : c
          ), !t.startsWith("#"))
            return e(t, r, i);
          const n = this.arguments[t.slice(1)];
          return n ? n.component ? e(
            n.component,
            {
              attrs: r,
              props: n.props,
              class: "rich-text--component"
            },
            i
          ) : e("span", r, [n]) : e("span", { attrs: r, class: "rich-text--fallback" }, [`{${t.slice(1)}}`]);
        },
        prefix: !1
      }).processSync(
        this.text.replace(/</gmi, "&lt;").replace(/&gt;/gmi, ">")
      ).result;
      return e("div", { class: "rich-text--wrapper rich-text--wrapper-markdown" }, [
        s,
        this.referenceLimit > 0 ? e("div", { class: "rich-text--reference-widget" }, [
          e(f, { props: { text: this.text, referenceData: this.references } })
        ]) : null
      ]);
    }
  },
  render(e) {
    return this.useMarkdown ? this.renderMarkdown(e) : this.renderPlaintext(e);
  }
}, U = null, Z = null;
var z = /* @__PURE__ */ g(
  P,
  U,
  Z,
  !1,
  null,
  "5f33f45b",
  null,
  null
);
const X = z.exports;
export {
  X as N,
  f as a
};
